import type { FunctionComponent } from 'react';

import './style.scss';

export const TypingIndicator: FunctionComponent = () => (
  <div styleName="container">
    <div styleName="dot" />
    <div styleName="dot" />
    <div styleName="dot" />
  </div>
);
